module.exports = __webpack_public_path__ + "022.1bbf838f.png";